module.exports = __webpack_public_path__ + "img/selected1-min.5b4068aa.png";